import { createSelector } from '@reduxjs/toolkit';
import { State } from './types';
import { RootState } from '../root-reducer';

const rootSelector = (state: RootState): State => state.ProductCodes;

export const statusSelector = createSelector(rootSelector, (productCodes) => productCodes.status);

export const errorSelector = createSelector(rootSelector, (productCodes) => productCodes.error);

const productCodesSelector = createSelector(rootSelector, (productCodes) => productCodes.data || []);

export const productCodesById = createSelector(
  productCodesSelector,
  (data) => (id: number) => data && data.find((dataItem) => dataItem.id === id)
);

export default {
  statusSelector,
  errorSelector,
  productCodesSelector,
  productCodesById,
};
